/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable import/no-mutable-exports */
/* eslint-disable import/no-extraneous-dependencies */
const { mergeDeep } = require('coreutils-js');

const scope = process.env.SCOPE;
const env = process.env.NODE_ENV || 'development';
const version = process.env.VERSION;

let config = {};

if (env) {
  try {
    config = mergeDeep(config, require(`./env/${env}.js`));
  } catch (err) {
    if (env === 'development') console.warn(err);
  }
}

if (scope && env) {
  try {
    config = mergeDeep(config, require(`./env/${scope}/${env}.js`));
  } catch (err) {
    if (env === 'development') console.warn(err);
  }
}

if (!Object.keys(config).length) {
  console.error('Cannot load config');
  process.exit(1);
}

config.scope = scope;
config.env = env;
config.version = version;
config.name = process.env.NAME;

module.exports = config;
